/**
 * @prop --vx-drawer-box-shadow-size: The size of the box shadow. Default: 8px
 * @prop --vx-drawer-box-shadow-color: The color of the box shadow. Default: rgb(0 0 0 / 32%)
 * @prop --vx-drawer-max-height: The maximum height of the drawer. Default: 500px
 * @prop --vx-drawer-max-width: The maximum width of the drawer. Default: 500px
 * @prop --vx-drawer-backdrop-filter: The backdrop filter. Default: #fff
 * @prop --vx-drawer-backdrop-color: The backdrop color. Default: #fff
 * @prop --vx-drawer-content-border-color: The border color of the drawer content. Default: #e5dfdf
 * @prop --animation-duration: The duration of the animation. Default: .3s
 * @prop --animation-delay: The delay of the animation. Default: .1s
 */
:host {
  display: block;
  user-select: none;
}
:host .backdrop {
  position: fixed;
  top: 100%;
  left: 0;
  width: 100vw;
  height: 0;
  opacity: 0;
  z-index: -11;
}
:host .wrapper {
  display: none;
  position: absolute;
  overflow: hidden;
  max-height: 0;
  width: 100vw;
  left: 0;
}
:host.open .wrapper {
  display: flex;
  transition: max-height ease-in-out var(--animation-duration, 0.3s);
  transition-delay: var(--animation-delay, 0.1s);
  max-height: var(--vx-drawer-max-height, 500px);
}
:host.open.touch-device .backdrop {
  opacity: 1;
  height: 100vh;
  animation: fade-in ease-in-out forwards, backdrop-animation ease-in-out forwards;
  animation-duration: var(--animation-duration);
  animation-delay: var(--animation-delay);
}
:host:hover:not(.touch-device) .wrapper, :host:focus-visible:not(.touch-device) .wrapper, :host:focus-within:not(.touch-device) .wrapper {
  display: flex;
  transition: max-height ease-in-out var(--animation-duration, 0.3s);
  transition-delay: var(--animation-delay, 0.1s);
  max-height: var(--vx-drawer-max-height, 500px);
}
:host .content {
  background-color: white;
  width: inherit;
  box-shadow: 0 var(--vx-drawer-box-shadow-size, 8px) var(--vx-drawer-box-shadow-size, 8px) var(--vx-drawer-box-shadow-color, rgba(0, 0, 0, 0.32));
  margin: calc(var(--vx-drawer-box-shadow-size, 8px)) 0 calc(var(--vx-drawer-box-shadow-size, 8px) * 2) 0;
}

@media screen and (min-width: 500px) {
  :host {
    position: relative;
  }
  :host .wrapper {
    max-width: var(--vx-drawer-max-width, 500px);
    left: unset;
    right: calc(var(--vx-drawer-box-shadow-size, 8px) * -1);
  }
  :host .content {
    border: 1px solid var(--vx-drawer-content-border-color, #e5dfdf);
    width: calc(100% - var(--vx-drawer-box-shadow-size, 8px) * 2);
    margin: calc(var(--vx-drawer-box-shadow-size, 8px) * 2) var(--vx-drawer-box-shadow-size, 8px);
  }
}